import React from "react"
import {Autoplay, Navigation, Pagination} from "swiper"
import {Swiper} from "swiper/react"
import {SwiperModule} from "swiper/types"
import "swiper/swiper-bundle.css"

type SwiperProps = {
	module?: React.ReactNode
	className?: string
	pagination?: {
		clickable?: boolean
	}
	breakpoints?: {[key: string]: {slidesPerView: number}}
	slidesPerView?: number
	spaceBetween?: number
	loop?: boolean
	navigation?: boolean
	modules?: SwiperModule[] | undefined
	autoplay?: {
		delay: number
		disableOnInteraction?: boolean
		pauseOnMouseEnter?: boolean
	}
	style?: React.CSSProperties
	classNameProp?: string
}

const MySwiper = (props: SwiperProps) => {
	const {
		module = null,
		className = "mySwiper",
		modules = [Pagination, Navigation, Autoplay],
		pagination = {
			clickable: true,
		},
		slidesPerView = 1,
		spaceBetween = 300,
		loop = false,
		navigation = true,
		style,
		classNameProp,
	} = props

	return (
		<Swiper
			autoplay={props.autoplay}
			breakpoints={props.breakpoints}
			className={`${className} ${classNameProp}`}
			loop={loop}
			modules={modules}
			navigation={navigation}
			pagination={pagination}
			slidesPerView={slidesPerView}
			spaceBetween={spaceBetween}
			style={{
				...style,
			}}
		>
			{module}
		</Swiper>
	)
}

export default MySwiper
